type DataEnvelope = {
  data?: unknown;
};

export type MaybeDataEnvelope<T> = T[] | DataEnvelope;

/**
 * Unwraps a list endpoint that may return either a bare array or a
 * `{ data: [...] }` envelope. Returns `[]` for any unrecognized shape.
 */
export const unwrapDataArray = <T>(response: unknown): T[] => {
  if (Array.isArray(response)) {
    return response as T[];
  }

  if (response && typeof response === 'object' && 'data' in response) {
    const data = (response as DataEnvelope).data;
    if (Array.isArray(data)) {
      return data as T[];
    }
  }

  return [];
};
